module.exports = __webpack_public_path__ + "img/kj3.06de8a3d.png";